module.exports = __webpack_public_path__ + "static/media/logo.620a38e4.png";